import { isNotEmpty } from '@lhb/func';
import { UrlSuffix } from '@/common/enums/qiniu';

/**
 * @description: 根据七牛文件的 url，获取原图后缀
 * @param {*} url
 * @return {*}
 */
export function getQiniuFileOriSuffix(url) {
  if (!url) {
    return '';
  }
  if (url.includes('middle-file.linhuiba.com')) {
    return '';
  } else if (url.includes('img.linhuiba.com')) {
    return UrlSuffix.Ori;
  } else if (url.includes('pmsimage.location.pub')) { // 来自 pms 的图片
    return UrlSuffix.PmsOri;
  } else if (url.includes('images.location.pub')) { // 来自 location 的图片
    return UrlSuffix.locationOri;
  } else {
    return '';
  }
}

/**
 * @description: 根据七牛文件的 url，获取原图链接
 * @param {*} url
 * @return {*}
 */
export function getQiniuFileOriUrl(url) {
  if (!url) {
    return '';
  }
  // 预处理掉链接本身的后缀
  url = url.replace(new RegExp(Object.values(UrlSuffix).join('|'), 'g'), '');
  return url + getQiniuFileOriSuffix(url);
}

/**
 * @description: 根据七牛文件的 url，获取预览后缀
 * @param {*} url
 * @return {*}
 */
export function getQiniuFilePreviewSuffix(url) {
  if (!url) {
    return '';
  }
  if (url.includes('middle-file.linhuiba.com')) {
    return '';
  } else if (url.includes('img.linhuiba.com')) { // 来自 邻汇吧场地 的图片
    return UrlSuffix.Wk;
  } else if (url.includes('pmsimage.location.pub')) { // 来自 pms 的图片
    return UrlSuffix.PmsLarge;
  } else if (url.includes('images.location.pub')) { // 来自 location 的图片
    return UrlSuffix.locationWx;
  } else {
    return '';
  }
}

/**
 * @description: 根据七牛文件的 url，获取预览链接
 * @param {*} url
 * @return {*}
 */
export function getQiniuFilePreviewUrl(url) {
  if (!url) {
    return '';
  }

  // 预处理掉链接本身的后缀
  url = url.replace(new RegExp(Object.values(UrlSuffix).join('|'), 'g'), '');
  return url + getQiniuFilePreviewSuffix(url);
}



/**
 * 根据七牛文件的 url 和宽高，获取小图
 * @description
 * @param url 链接，如 https://cert.linhuiba.com/FlMVw4wDiy9VFr94sh-ujADo4wQV
 * @param width 宽度，默认 50
 * @param height 高度，不传默认使用 width
 * @return
 * @demo
    getQiniuFileUrlWithSize('https://cert.linhuiba.com/FlMVw4wDiy9VFr94sh-ujADo4wQV', 40, 40);
 */
export function getQiniuFileUrlWithSize(url: string, width: string | number, height?: string | number) {
  if (!isNotEmpty(url) || typeof url !== 'string') {
    return url;
  }

  const defaultWidth = 50;
  if (!isNotEmpty(width)) {
    width = defaultWidth;
  }
  if (!isNotEmpty(height)) {
    height = width;
  }
  const imgSuffix = `&imageView2/1/w/${width}/h/${height}`;
  if (url.indexOf('?') > -1) {
    const query = url.split('?')[1];
    if (query?.indexOf('imageView') > -1) { // 如果用户设置了，就不去管他
      return url;
    } else {
      return url + imgSuffix;
    }
  } else {
    return url + '?v=1' + imgSuffix;
  }
}

